import React from "react";

const Support = () => {
    return <p>Please reach out to support@gethale.ai if you are facing any issues</p>;
};

export default Support;